module.exports = __webpack_public_path__ + "static/media/hani.ebe3a637.jpg";